var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: ".._.._src_svg_Icn_40px_Loading__pattern-1",
    width: "100%",
    height: "100%",
    patternUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#.._.._src_svg_Icn_40px_Loading__image-2"
  })), /*#__PURE__*/React.createElement("image", {
    id: ".._.._src_svg_Icn_40px_Loading__image-2",
    width: 24,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAGKADAAQAAAABAAAAGAAAAADiNXWtAAADk0lEQVRIDY2Vy24TQRBF5+VHFOchwCAkImXLhk1W2WXLF/MJfAQCRWKBFAtDQhz8GI85p9xt2SwQI11Xd033vVXV5Z6yLMtlURQdtkt2zThQVVWbxto2zQ9sXoNdi7RePuddtdlsaoi1lTaDedl18b7EJ/afDZs3kAQkYpwD3JHra9i1VoRJgZXEHzcq5qZSMR/GPk7C8hOkWnw7ZEF9knwFvxXBRkaMsw0f/hDRAh+D6MxCskQYJWJsmfRty8zC24T7fRF8Ua5UJseZnGFkocga5JLszkDyDEv0BfwCM/AGkdeWAMt0GylWohBgY0TPPCLfRZoj3pJbOkWiLG+ZPIHfYAEkeAHy49y67zqrrutVBiQt4+gsxfbQ4V9b4+fA6B+TVUwhRcywsKYJkkm+FJCtmqZZZREJFdAaEONOAdO5T/iZ7ANWwWfgmMWYwo0SLyCda3u93iL5DkR25CmDKZvvwHcwSXCefSPGr8yAiJaQP0E86/f7WoX0mYlliugj8m02kQH7o+5zrJl8A5/ALfic0HLo79i4GA6H06Ojox+DwWBmJohEmRRALErEOMpDUJv91oPrn88VGz5eXFx8ODk5mUDsGVjraALGWp9sY/K/AvX19XV/Pp+/hPg9pGN294FnyDQOKbjI9IAzuiSktn3uy/Lm5qacTCbV6elpPZ1Om7OzM8lHkI+J9I4/n6zHkA2witSM48+YxbKQAs3V1VUJQblYLMrxeFxBWo1Go/rh4aE5Pz/vLZfLIYd6DHEfLCF5hEAR77GeHIz3L0wDDcHm8vKyYXNErjNdDXXbtjUHKnmfyAeSQ+Kl6H9CkTm+goziX8vYd7X7feDy/qp2ZcDRw98zIhb2JBSKaPE1vCtZI2ELVviWvAswXunjvR0n7KS2IbqGQUkWRm8UlWQs1i+pwrVYr9clsEsMU5I4ZOZxd7EvOoopr2krM4CY9q2b2cy2biQKYscKWSp8kTrrokOYd0YIUb6DzOgA+X3D4dZGn1Rr55lcYqMkM6MJcqNkHjcpe7IQSyu/gLiib1keTVBF1BykmVTYmpJZIg9ZG8LscWEIBAMVgcxymIVr4jpHpEgi8dVTxRIckFuv1cqzqqIrFAEHXzSnkBputvHRMeo9Ec9lY4vuIucAI2KirZJIbt/8XYZzexXsiRB01MY4LFNYxRgUTS6L5BKbES+jJCyo7BxI98vjxugWyMIyD9a/yRX5A4edXnK0FytpAAAAAElFTkSuQmCC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Loading__Icn/40px/Loading",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Loading__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Loading__Rectangle"
  })), /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Loading__Group-Copy-2",
    transform: "translate(-5 -4.433)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17,5.43286133 C23.627417,5.43286133 29,10.8054443 29,17.4328613 C29,24.0602783 23.627417,29.4328613 17,29.4328613 C10.4745433,29.4328613 5.16560725,24.224317 5.00379986,17.7378361 L5,17.4328613 L7,17.4328613 C7,22.9557088 11.4771525,27.4328613 17,27.4328613 C22.5228475,27.4328613 27,22.9557088 27,17.4328613 C27,11.9100138 22.5228475,7.43286133 17,7.43286133 C14.0999091,7.43286133 11.4043305,8.67361453 9.52134291,10.7941214 L9.31549696,11.0333353 L7.77939304,9.75256027 C10.0448862,7.03542981 13.3927428,5.43286133 17,5.43286133 Z",
    transform: "scale(-1 1) rotate(45 -12.45 -29.698)",
    id: ".._.._src_svg_Icn_40px_Loading__Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/Loading.e97c6841fe9e7919d9754519141fbe52.svg";
export { ForwardRef as ReactComponent };